import React from 'react'
import { connect, batch } from 'react-redux';
import Accounts from "../classes/accounts"
import Page from '../classes/page';
import Project from '../classes/project'
import Navbar from '../components/navbar';
import HistoryDataProcessor from "../classes/HistoryDataProcessor"
import { ErrorProject, LoginRequired } from '../components/errorproject';
import LiveBanner from '../components/livebanner';
import Modals from './modals';
import Report from './report';
import Footer from '../components/footer';
import ExeptionsTrapper from "./ExceptionsTrapper"
import AlertMessage from "../components/modals/alert_message"
import { randomUuid } from '../classes/lib-common';
import { ComponentpediaLanguages } from '../components/report/componentpedia';
import MeterianSDK from '../classes/MeterianSDK';
import { branchForExclusion, branchForRemoval } from "../classes/exclusionBranch";


import { setAuthState, setProjectInfo, setReportReady, 
	updateBadges, setHistoryData, setHistoryRaw, setRecomputeReminder,
	setProjectLicensingInfo } from '../state/actions/app';

import '../style/report.css';

const mapStateToAppProps = state => ({
	auth: state.setUser.auth,
	user: state.setUser.user,
	urlParams: state.projectInfo.urlParams,
	showReport: state.projectInfo.reportReady && Object.keys(state.projectInfo.summary).length > 0 && state.projectInfo.security,
	isExperimental: state.projectInfo.isExperimental,
	projectLicensingInfo: state.projectInfo.licensing,
	lastCompletedApproval: state.libraryApprovalState.lastCompletedApproval
})

const mapStateToProps = state => ({
	auth: state.setUser.auth,
	user: state.setUser.user,
	projectInfo: state.projectInfo,
	urlParams: state.projectInfo.urlParams
})

const mapDispatchToProps = dispatch => ({
	setAuthState: (user, successful) => dispatch(setAuthState(user, successful)),
	setProjectInfo: (data, refresh, reset) => dispatch(setProjectInfo(data, refresh, reset)),
	updateBadges: (badges) => dispatch(updateBadges(badges)),
	setHistoryData: (data) => dispatch(setHistoryData(data)),
	setHistoryRaw: (data) => dispatch(setHistoryRaw(data)),
	setReportReady: (state = true) => dispatch(setReportReady(state)),
	setRecomputeData: (newHistory, newReport, newRawHistory) => batch(() => {
		dispatch(setHistoryData({ processed: newHistory, selection: newReport.report.uuid }))
		dispatch(setHistoryRaw(newRawHistory))
	}),
	refreshData: (newHistory, newReport, newRawHistory, newBadges) => batch(() => {
		dispatch(setHistoryData({ processed: newHistory, selection: newReport.report.uuid }))
		dispatch(setHistoryRaw(newRawHistory))
	}),
	setRecomputeReminder: (recomputed) => dispatch(setRecomputeReminder(recomputed)),
	setProjectLicensingInfo: (report) => dispatch(setProjectLicensingInfo(report))
	
})

const Loader = () => (
	<div id="loading-main">
		<div className="spinner-border text-primary" role="status">
			<span className="sr-only">Loading...</span>
		</div>
	</div>
)

const NullAuthLoader = connect(mapStateToProps, mapDispatchToProps)((props) => (
	props.auth === null ?
		<Loader /> :
		""
))
const ReportNotReadyLoader = connect(mapStateToProps, mapDispatchToProps)((props) => (
	!props.projectInfo.errorProject && !props.projectInfo.reportReady ?
		<Loader /> :
		""
))
const LoginPane = connect(mapStateToProps, mapDispatchToProps)((props) => (
	props.auth === false ?
		<LoginRequired /> :
		""
))

const ErrorProjectWrapper = connect(mapStateToProps, mapDispatchToProps)((props) => (
	props.projectInfo.errorProject ?
		<ErrorProject status="FAILED" /> :
		""
))

const MainReportPane = connect(mapStateToProps, mapDispatchToProps)((props) => {
	const getReportHistory = async () => {
		return await props.getReportHistory(props.projectInfo.uuid, props.urlParams.branch, props.headers);
	}
	return props.projectInfo.reportReady && Object.keys(props.projectInfo.report).length && !props.projectInfo.errorProject ?
		<React.Fragment>

			<Report
				getReportHistory={getReportHistory}
				loadPage={props.loadPage}
				renderId={props.renderId}
				recompute={props.recompute}
				openDependenciesTree={props.openDependenciesTree}
				findDependencyInTree={props.findDependencyInTree}
				rendersCount={props.rendersCount}
				projectsController={props.projectsController}
			/>
		</React.Fragment>
		:
		""
})
const GlobalAlert = (props)=>{
	if(!props.globalAlertMessage) return null
	setTimeout(()=>{
		props.closeGlobalMessage()
	}, 15 * 1000)
	return props.globalAlertMessage ? 
	<div style={{position: "fixed", top: "110px", right: "16px", left: "16px", zIndex: "500"}}>
		<div className="alert alert-danger">
			<button href="#" className="close" data-hide="alert" data-testid="close-error-message" onClick={props.closeGlobalMessage} style={{pointerEvents: "all"}}>&times;</button>
			<strong><span id="message" dangerouslySetInnerHTML={{__html: props.globalAlertMessage}}></span></strong>
		</div>
	</div> : null
}
const ReportPane = (props) => {
	return (
	<div id="main-report-pane" className={"projects" + (props.isExperimental ? " experimental" : "")}>
		<LiveBanner />
		<Modals mitigate={props.mitigate} removeMitigation={props.removeMitigation} fixLicense={props.fixLicense} loadPage={props.loadPage} setAlertMessage={props.setAlertMessage} />
		<MainReportPane ref={props.mainReportPaneRef} headers={props.headers}
			dependencyFilter={props.dependencyFilter}
			getReportHistory={props.getReportHistory} loadPage={props.loadPage} renderId={props.renderId} recompute={props.recompute}
			openDependenciesTree={props.openDependenciesTree} findDependencyInTree={props.findDependencyInTree} rendersCount={props.rendersCount} projectsController={props.projectsController}
		/>
	</div>
)}

const ReportWrapper = (props) => {
	return props.auth ?
	<React.Fragment>
		<GlobalAlert globalAlertMessage={props.globalAlertMessage} closeGlobalMessage={props.closeGlobalMessage}/>
		<ErrorProjectWrapper />
		<ReportNotReadyLoader />
		<ReportPane isExperimental={props.isExperimental} fixLicense={props.fixLicense} mitigate={props.mitigate} 
			removeMitigation={props.removeMitigation} loadPage={props.loadPage} mainReportPaneRef={props.mainReportPaneRef} headers={props.headers}
			dependencyFilter={props.dependencyFilter} getReportHistory={props.getReportHistory} renderId={props.renderId} recompute={props.recompute}
			openDependenciesTree={props.openDependenciesTree} findDependencyInTree={props.findDependencyInTree} rendersCount={props.rendersCount} projectsController={props.projectsController}
			setAlertMessage={props.setAlertMessage}
		/>
	</React.Fragment> :
	""
}


class App extends React.Component {
	constructor() {
		super();

		this.auth = window.auth;
		this.headers = null;

		this.page = null;
		this.project = null;
		this.historyDataProcessor = new HistoryDataProcessor()

		this.rendersCount = 0;

		this.mainReportPaneRef = React.createRef()
		this.dependencyFilter = React.createRef();

		this.latestReportUuid = null

		// The exclusions on screen, keyed by id, so that a removal can look up
		// the branch its exclusion was recorded on. See demitigate.
		this.exclusionsById = {}

		this.state = {
			alert: {
				type: null,
				message: null
			},
			globalAlertMessage: null
		}

	}

	componentDidMount(){
		window.onbeforeunload = ()=>{
			if ( this.dependencyTree ){
				this.dependencyTree.close()
			}
		} 

		

		const collectUrlParameters = () => {

			let search = {};
			const params = (window.location?.search.split('?')[1] || '').split('&');
			for (let param in params) {
				if (params.hasOwnProperty(param)) {
					let paramParts = params[param].split('=');
					search[paramParts[0]] = decodeURIComponent(paramParts[1] || "");
				}
			}
			this.urlParams = search;
			if(!this.urlParams.pid && this.urlParams.id) this.urlParams.pid = this.urlParams.id
		}

		const performAuthentication = async () => {

			const { mode, login } = this.urlParams;

			const enableLogin = (mode === 'eli') || (login === 'true');

			if (enableLogin){
				try{
					window.auth.initializeAuth(null, this.userAuthenticated, this.userNotAuthenticated)
				} 
				catch(e){
					window.debug(e)
				}
			}
			else {
				const accounts = new Accounts(null);
				const defaultUser = {
					name: "Default",
					email: "info@meterian.com",
					account: await accounts.default(),
					membership: {
						name: "Default"
					}
				}
				this.userAuthenticated(defaultUser)
			}

		}

		const syncronouslyAddModifiedFetchWhenFound = async () => {
			while (!window.addSessionCheckToFetchRoutine) {
				await new Promise(resolve => {
					setTimeout(resolve, 500)
				})
			}
			window.addSessionCheckToFetchRoutine(this.userNotAuthenticated)
		}
		if (window.dependencyTree){
			this.dependencyTree = window.dependencyTree
			this.openDependenciesTree()
		}
		syncronouslyAddModifiedFetchWhenFound()
		.then(async() => {
			collectUrlParameters();
			performAuthentication();
		})

	}

	// A library-policy approval completes in one of two places - the update
	// path inside ApproveLibrary.js, or the create modal in
	// approve_library.js - and both are rendered far from here. What they
	// produce (an info alert, and lighting the Recompute Report button's
	// glow) is global chrome, not something either path owns, so it is raised
	// once here from the one signal both paths dispatch, rather than
	// duplicated in each. Comparing against the previous prop keeps this
	// firing exactly once per approval: componentDidUpdate never runs on
	// mount, and reference equality holds whenever the store's
	// lastCompletedApproval field itself did not change, including on
	// unrelated re-renders.
	componentDidUpdate(prevProps) {
		const previousApproval = prevProps.lastCompletedApproval
		const currentApproval = this.props.lastCompletedApproval
		if (!currentApproval || currentApproval === previousApproval) return
		this.setAlertMessage("info", "The library was approved; recompute this report for the change to take effect.")
		// setRecomputeReminder's argument is "has this been recomputed", not
		// "should the glow show": passing a truthy value turns the glow OFF
		// (see recomputeReminderState in state/reducers/app.js and its use at
		// line ~554 after an actual recompute). Lighting the glow - the whole
		// point here - means passing a falsy value, the same as the existing
		// exclusion flows below do when they want the reminder ON.
		this.props.setRecomputeReminder(false)
	}



	userAuthenticated = async (user) => {


		const setDefaultHeaders = () => {
			this.headers = {
				'Content-Type': 'application/json',
				'Authorization': window.auth.helpers.header()
			}
		}
		const verifySession = async () => {
			const accessToken = window.AuthUtils.getTokenFromLocalStorage()
			if (!mode && accessToken) {
				const accounts = new Accounts({ "Authorization": "Bearer " + accessToken });
				const isTokenValid = await accounts.get();
				if (isTokenValid) this.headers['Authorization'] = "Bearer " + accessToken;
				else window.AuthUtils.removeAccessToken();
			}
		}
		const clearHeadersIfNoAccessToken = () => {
			const accessToken = window.AuthUtils.getTokenFromLocalStorage()
			if (!mode && !accessToken) {
				this.headers = null
			}
		}

		const loadPage = () => {
			const loadPageDependencies = () => {
				this.page = new Page(this.headers, this.urlParams, user);
				this.project = new Project(this.headers);
			}


			loadPageDependencies();

			if (window.auth.lock) window.auth.lock.hide();
			this.loadPage();

		}



		this.props.setAuthState(user, true);

		const { mode } = this.urlParams;
		const shouldEnforceLogin = this.urlParams.mode === "eli"
		window.meterian = new MeterianSDK()
		if(user) await window.meterian.load(user)
		window.componentpediaLanguages = new ComponentpediaLanguages()
		setDefaultHeaders();
		await verifySession();
		await window.componentpediaLanguages.get()
		clearHeadersIfNoAccessToken()
		loadPage();

	}



	userNotAuthenticated = () => {
		const showLoginPane = () => {
			setTimeout(async() => {
				window.auth.lock.showLock();
			}, 300)
		}

		this.props.setAuthState(null, false);

		showLoginPane();
		if(localStorage.loginAttempt){
			localStorage.removeItem("loginAttempt")
            window.$("#cog0-error").text("THIS USER IS NOT IN THE SYSTEM").show()
            setTimeout(()=>{
                window.$("#cog0-error").hide()
            },5000)
        }
	}

	loadPage = async (reportUUID = null, isLatestReport = true) => {


		const resetProjectInfoForSpecificReportRequest = () => {
			if (reportUUID) {
				this.props.setProjectInfo(null, null, true)
			}
		}

		if(this.urlParams.reportUuid && this.urlParams.reportUuid.length && !reportUUID) {
			reportUUID = this.urlParams.reportUuid
		} 
		resetProjectInfoForSpecificReportRequest()
		this.rendersCount++
		await this.loadPageInfo(reportUUID, isLatestReport)

	}

	loadPageInfo = async (reportUUID = null) => {

		const getProjectInfo = async (pid) => {
			try {
				return await this.project.get(pid);
			}
			catch (e) {
				throw { ...this.page.projectError() }
			}
		}

		const processProjectInfo = (project) => {

			const projectParams = this.page.processProjectInfo(project);
			return { projectInfo: project, ...projectParams, errorProject: false };

		}


		const isDownloadAvailable = (report, isOpensource, isPublic) => {
			const isDownloadAvailable = (isPublic || !isOpensource) && report.downloadKey && report.downloadKey.length > 0
			return { isDownloadAvailable }
		}

		const isLatestReport = reportUUID === this.latestReportUuid || !reportUUID

		let state = {};
		try {
			const { pid } = this.urlParams;

			const project = await getProjectInfo(pid);
			const projectInfo = processProjectInfo(project)
			if (projectInfo.titleState.isUserAdmin) {
				const accessToken = window.AuthUtils.getTokenFromLocalStorage()
				const accounts = new Accounts({ "Authorization": "Bearer " + accessToken });
				const projectAccount = await accounts.get(projectInfo.accountUuid)
				projectInfo.accountInfo = projectAccount
			}
			// this goes here because, if report is not found, UI should show basic info about the projects
			// and make it possible to switch branch
			state = { ...state, ...projectInfo, isLatestReport }
			const jiraInfo = await this.getProjectJiraInfo(projectInfo.accountUuid, pid, projectInfo.titleState.hasJiraFeature)
			const { report, badges, history, rawHistory } = await this.reloadReport(reportUUID, false, jiraInfo)
			const reportState = { report: report.report, errorReport: false}
			const downloadState = isDownloadAvailable(report.report, projectInfo.titleState.isAccountOpensource, projectInfo.titleState.isPublic)
			state.titleState = { ...projectInfo.titleState, ...downloadState, ...badges };
			state = {...state, ...reportState, jira: jiraInfo}


			let licensingReports = Object.deepClone(report.licensing.section.standard)
			for(const entry of report.licensing.section.standard) {
				entry.results = entry.results.slice(0, 1000)
			}
			this.props.setProjectInfo(state)
			if (report.status !== "OK" && report.status !== "PARTIAL") {
				this.props.setProjectInfo({ ...report })
			}
			this.props.setProjectInfo({ urlParams: this.urlParams, reportReady: true })
			

			if(!this.latestReportUuid) this.latestReportUuid = report.uuid
			this.props.refreshData(history, report, rawHistory)

			// let iterations = 1
			// while (true) {
			// 	iterations++
			// 	await new Promise(resolve=>{setTimeout(resolve, 250)})
			// 	let complete = 0
			// 	for(let i = 0; i<licensingReports.length; i++) {
			// 		const entry = licensingReports[i]
			// 		let sliceSize = 5000 * iterations
			// 		if (sliceSize > entry.results.length) { sliceSize = entry.results.length; complete++ }
			// 		report.licensing.section.standard = report.licensing.section.standard.slice(0, sliceSize)
			// 	}
			// 	if(licensingReports.length <= complete) break
			// }
			report.licensing.section.standard = licensingReports
			setTimeout(()=>{
				this.props.setProjectInfo({ ...report })
			},1000)

		}
		catch (e) {
			console.log(e)
			this.props.setProjectInfo({ ...state, ...e, urlParams: this.urlParams, reportReady: true })
		}
	}

	async getProjectJiraInfo(accountUuid, pid, hasJiraFeature) {
		try{

			if (!hasJiraFeature) return null
			const config  = await window.meterian.accounts.integrations.jira.configuration.get(accountUuid)
			const projectMeta = await window.meterian.accounts.integrations.jira.projects.get(accountUuid, pid)
			const issues = await window.meterian.accounts.integrations.jira.projects.issues.list(accountUuid, pid)
			issues.issues = window.meterian.accounts.integrations.jira.projects.issues.convertToMap(issues)
			issues.baseurl = config.baseurl
			issues.projectKey = projectMeta.projectKey
			return { projectMeta, issues }
		}
		catch(e){
			return null
		}
	}
	

	reloadReport = async (reportUUID = null, storeInfo=true, jiraInfo=null) => {
		const getBadges = async (pid, branch, report) => {
			
			const badgesInfo = [
				{domain: "security", score: report.security.score},
				{domain: "stability", score: report.stability.score},
				{domain: "licensing", score: report.licensing.score}
			]
			const badges = await window.meterian.reports.badges.getMany(badgesInfo, pid, branch, reportUUID)
			this.props.updateBadges({
				securityBadge: badges.security,
				stabilityBadge: badges.stability,
				licensingBadge: badges.licensing
			})
		}
		const getReport = async (pid, branch, reportUUID) => {
			try {
				return reportUUID ?
					await this.project.reports.get(pid, reportUUID) :
					await this.project.reports.getByPid(pid, branch);
			}
			catch (e) {
				throw { ...this.project.reports.reportError(e) }
			}
		}

		if ( reportUUID && this.dependencyTree ){
			this.dependencyTree.close()
		}
		// if (!this.urlParams.branch) this.urlParams.branch = project.branches[0];
		const { pid, branch } = this.urlParams;
		const rawReport = await getReport(pid, branch, reportUUID);
		let newExclusions = rawReport.exclusions
		let recentlyExpiredExclusions = []
		try{
			const fetchedExclusions = await this.project.reports.exclusions.get(pid, branch)
			// A failed refresh must not leave the previous branch's banner on screen, so
			// the expired set is only ever taken from a fetch that actually succeeded.
			if(fetchedExclusions){
				newExclusions = fetchedExclusions.live
				recentlyExpiredExclusions = fetchedExclusions.recentlyExpired
			}
		}
		catch(e){}
		this.exclusionsById = this.project.reports.exclusions.map(newExclusions) || {}
		if(jiraInfo) rawReport.jiraInfo = jiraInfo.issues
		const newReport = this.project.reports.preprocess(rawReport, newExclusions)
		newReport.recentlyExpiredExclusions = recentlyExpiredExclusions
		const newBadges = getBadges(pid, branch, newReport.report)
		const newRawHistory = await this.project.history(pid, branch)
		const newHistory = this.historyDataProcessor.process(newRawHistory, newReport.report.thresholds)
		if(storeInfo){
			this.renderId = randomUuid();
			this.props.setProjectInfo(newReport)
			this.props.refreshData(newHistory, newReport, newRawHistory, newBadges)
			setTimeout(async () => {
				await this.closeLoader(true)
			}, 100)
		}

		return {
			report: newReport, badges: newBadges, history: newHistory, rawHistory: newRawHistory
		}
	}



	openLoader = () => {
		window.$("#loading").modal('show');
	}
	closeLoader = async (immediate=false) => {
		const doClose = (callback)=>{
			window.$("#loading").modal('hide');
			window.$(".modal-backdrop").remove()
			if (callback) callback()
		}
		if (immediate) {
			await new Promise(resolve => {
				setTimeout(() => {
					doClose(resolve)
				}, 500);
			})
		}
		await new Promise(resolve => {
			setTimeout(() => {
				doClose(resolve)
			}, 1000);
		})
		return

	}

	recomputeReport = async (partial) => {
		this.props.setProjectInfo(null, null, true);
		const { pid, branch } = this.props.urlParams;
		const report = await this.project.reports.recompute(pid, branch, partial);
		this.latestReportUuid=null
		const newRawHistory = await this.project.history(pid, branch)
		const newHistory = this.historyDataProcessor.process(newRawHistory, report.report.thresholds)
		this.renderId = randomUuid();


		this.props.setRecomputeData(newHistory, report, newRawHistory)
		this.props.setRecomputeReminder(true)
		this.loadPage()
	}

	

	mitigate = async (newMitigation, isFirst = true, shouldLoadPage = true, willRecompute = false, transitive = false, applyToAllBranches = false) => {
		try {
			if (isFirst) this.openLoader();

			const { pid, branch } = this.props.urlParams;
			await this.project.reports.exclusions.create(pid, branchForExclusion(branch, applyToAllBranches), newMitigation, this.props.user.membership.uuid);
			if (shouldLoadPage && willRecompute) {
				await this.closeLoader(true)
				this.recomputeReport(transitive);
			}
			if (shouldLoadPage && !willRecompute){
				this.reloadReport(null, true);
			}
			if (isFirst && !willRecompute) {
				this.props.setRecomputeReminder(false)
			}
		}
		catch (e) {
			console.log(e)
			// The modal is dismissed before the request is sent, so without this
			// a rejected exclusion is indistinguishable from a saved one.
			this.setAlertMessage("danger", "The exclusion could not be saved.")
			if (shouldLoadPage) this.closeLoader(false);
		}
	}


	async createJiraIssue (){
			try{
				const jiraIssue = this.createJiraIssueObject()
				await window.meterian.accounts.integrations.jira.projects.issues.create(this.props.accountInfo.uuid, this.props.jiraState.projectUuid, jiraIssue)
				window.$("#jira-issue-dialog").modal("hide")
				this.props.setJiraIssue()
				this.setState({ready: false})
				this.openLoader();
				this.reloadReport(null, true);
			}
			catch(e){
				this.setState({errorMessage: e.message})
			}
		}

	demitigate = async (advice, transitive, isFirst = true, shouldLoadPage = true, willRecompute = false) => {
		try {
			if (isFirst) this.openLoader();

			const { pid, branch } = this.props.urlParams;
			await this.project.reports.exclusions.remove(pid, branchForRemoval(branch, this.exclusionsById[advice]), advice);
			if (shouldLoadPage && willRecompute) {
				await this.closeLoader(true)
				
				this.recomputeReport(transitive);
			}
			if (shouldLoadPage && !willRecompute){
				this.reloadReport(null, true);
				await this.closeLoader(true)
			}

			if (isFirst && !willRecompute) {
				
				this.props.setRecomputeReminder(false)
			}
		}
		catch (e) {
			if (willRecompute) this.closeLoader(false);
			
		}
	}


	setAlertMessage(type, message, timeOnScreen=5000) {
		this.setState({
			alert: {
				type,
				message
			}
		})

		setTimeout(() => {
			this.setState({
				alert:{
					type: null,
					message:null
				}
			})
		}, timeOnScreen)
	}

	fixLicense = async (library, recompute, performOperationOnLicenses) => {
		const { language, name } = library.library
        const { version } = library
		const findLicenseComponent = async (language, name, version, licensingReport) => {
			const results = licensingReport.section.standard.filter((report) => report.language === language)[0].results
			return results.filter((component) => component.version === version && component.library.name === name)[0]
		}
		try {
			this.openLoader();
			const {updatedComponentLicenses, operationResults} = await performOperationOnLicenses()
			let errorMessage = operationResults.notAdded.length + operationResults.notDeleted.length > 0 ? "An error occurred when processing the request<br/><br/>":""
			if (operationResults.notAdded.length > 0) {
				errorMessage+="<b>Licenses not added:</b><br/><ul>"
				for (const entry of operationResults.notAdded) {
					errorMessage+=`<li> ${entry.license} - ${entry.reason}</li>`
				}
				errorMessage+="</ul>"
				if (operationResults.notDeleted.length > 0)
					errorMessage+="</br>"
			}
			if (operationResults.notDeleted.length > 0) {
				errorMessage+="<b>Licenses not removed:</b><br/><ul>"
				for (const entry of operationResults.notDeleted) {
					errorMessage+=`<li> ${entry.license} - ${entry.reason}</li>`
				}
				errorMessage+="</ul>"
			}
			if(recompute) {
				await this.closeLoader(true)
				await this.recomputeReport();
				if(errorMessage.length){
					this.setState({globalAlertMessage: errorMessage})
				}
				return
			}
			const licensingReport = this.props.projectLicensingInfo
			const component = await findLicenseComponent(language, name, version, licensingReport)
			component.licenses = [...updatedComponentLicenses]
			component.warnings = updatedComponentLicenses.length ? []: ["We were not able to find a valid license."]
			await this.props.setProjectLicensingInfo(licensingReport)
			await this.closeLoader();
			this.props.setRecomputeReminder()
			if(errorMessage.length){
				this.setState({globalAlertMessage: errorMessage})
			}
			
		}
		catch (e) {
			this.closeLoader(false);
			throw (e)
		}
	}


	openDependenciesTree = () => {
		const {pid, branch, mode} = this.props.urlParams
		if (!this.dependencyTree || this.dependencyTree.closed ){
			window.dependencyTree = this.dependencyTree = window.open(`/projects/tree?pid=${pid}&branch=${window.cleanEncodeURIComponent(branch)}${mode?('&mode='+mode):""}`)
		}
		else{
			this.dependencyTree.focus()
		}
	}

	findDependencyInTree = async (language, dependency, start) => {
		if (Date.now() - start > 60 * 1000) return
		if ( !start ) {
			start = Date.now()
		}

		this.openDependenciesTree()
		
		if ( !this.dependencyTree.searchDependency ) {
			await new Promise(resolve=>setTimeout(resolve, 1000))
			this.findDependencyInTree(language, dependency, start)
			return 
		}
		this.dependencyTree.searchDependency(dependency, language)
	}

	closeGlobalMessage() {
		this.setState({globalAlertMessage: null})
	}


	render() {
		return (
			<React.Fragment>
				<AlertMessage type={this.state.alert.type} message={this.state.alert.message} />
				<Navbar />
				<NullAuthLoader />
				<LoginPane />
				<ExeptionsTrapper>
					<ReportWrapper auth={this.props.auth} isExperimental={this.props.isExperimental} 
						mitigate={this.mitigate.bind(this)} removeMitigation={this.demitigate.bind(this)} fixLicense={this.fixLicense.bind(this)} loadPage={this.loadPage.bind(this)}
						mainReportPaneRef={this.mainReportPaneRef} headers={this.headers} dependencyFilter={this.dependencyFilter}
						getReportHistory={this.project ? this.project.history : null} renderId={this.renderId} recompute={this.recomputeReport.bind(this)}
						openDependenciesTree={this.openDependenciesTree.bind(this)} findDependencyInTree={this.findDependencyInTree.bind(this)}
						rendersCount={this.rendersCount} projectsController={this.project} globalAlertMessage={this.state.globalAlertMessage} closeGlobalMessage={this.closeGlobalMessage.bind(this)}
						setAlertMessage={this.setAlertMessage.bind(this)}
					/>
				</ExeptionsTrapper>
				<Footer />
			</React.Fragment>

		);
	}
}




export default connect(mapStateToAppProps, mapDispatchToProps)(App);
